export const getTrackJson = (track) => {
    let trackData = track.getJson();
    var patterns = [];

    for (var p=0; p < track.sequencerEngine.numberOfPatterns(); p++) {
        var pattern = track.patterns[p];
        if (pattern === undefined) {
            continue;
        }
        var stepBuckets = {};
        for (var bucketNumber=0;
             bucketNumber < pattern.stepBuckets.length;
             bucketNumber++) {
            var stepBucket = pattern.stepBuckets[bucketNumber];
            if (stepBucket.anyEffectAutomation() || stepBucket.anyOn()) {
                for (var key in stepBucket.steps) {
                    stepBuckets[bucketNumber] = stepBucket.getJson();
                }
            }
        }
        stepBuckets.size = pattern.length();
        stepBuckets['buckets'] = true;
        patterns.push(stepBuckets);
        
    }

    return {
        patterns,
        patternsConfig: track.patterns.map(pat => pat.getJson()),
        trackData,
        trackEffectChains: track.effectsChains.map(
            x => x.getJson()),
        trackMidiEffects: track.midiEffects.getJson()
    };
}
